export default __webpack_public_path__ + "static/media/conectividad.e2820dde.png";